var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.122681C13.3618 0.122681 14.8826 1.58869 14.9679 3.42755C18.2118 4.79935 20.3962 7.99962 20.3962 11.6223V16.1876C21.8504 16.299 23 17.5163 23 19V20.737C23 21.5766 22.3183 22.2548 21.48 22.2548H1.51997C0.679776 22.2548 0 21.5764 0 20.737V19C0 17.5181 1.14814 16.2991 2.60377 16.1876V11.6223C2.60377 8.00133 4.78875 4.80046 8.03206 3.42806C8.11723 1.58856 9.63947 0.122681 11.5 0.122681ZM20.8302 20.0849V19C20.8302 18.6423 20.5364 18.3491 20.1783 18.3491C19.1003 18.3491 18.2264 17.4752 18.2264 16.397V11.6223C18.2264 8.67691 16.3164 6.10042 13.5557 5.21576L12.8019 4.97419V3.59071C12.8019 2.87505 12.2187 2.29249 11.5 2.29249C10.7822 2.29249 10.1981 2.87521 10.1981 3.59071V4.97433L9.44452 5.21601C6.68433 6.1012 4.77358 8.67869 4.77358 11.6223V16.397C4.77358 17.4748 3.89833 18.3491 2.82166 18.3491C2.46321 18.3491 2.16981 18.6428 2.16981 19V20.0849H20.8302ZM7.37736 22.2548H9.54717C9.54717 23.3333 10.4215 24.2076 11.5 24.2076C12.5785 24.2076 13.4528 23.3333 13.4528 22.2548H15.6226C15.6226 24.5316 13.7769 26.3774 11.5 26.3774C9.22313 26.3774 7.37736 24.5316 7.37736 22.2548Z",
    fill: "#FFB53A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.338402cd0c66e42e5724b030f4ebf9e8.svg";
export { ForwardRef as ReactComponent };